<template>
    <view-card headline="계약정보" :disabled="disabled">
        <v-row>
            <v-col cols="6" class="py-0">
                <div class="caption">계약번호</div>
                <div class="subtitle-1">
                    {{ value.contractNumber ? value.contractNumber : "자동부여" }}
                </div>
            </v-col>
            <v-col cols="6" class="py-0">
                <v-select v-model="value.isWhole" :items="contractTypes" label="계약형태" placeholder=" " hide-details />
            </v-col>
        </v-row>
    </view-card>
</template>
<script>
import ViewCardRow from "../dumb/view-card-row.vue";
import viewCard from "../dumb/view-card.vue";
export default {
    components: { viewCard, ViewCardRow },
    props: {
        value: {
            contractNumber: { type: String, default: null }, // 계약번호
            isWhole: { type: Boolean, default: null }, // 계약형태 : ( true = 종합인테리어 || false = 부분인테리어 )
        },
        disabled: { type: Boolean, default: true },
    },
    data() {
        return {
            contractTypes: [
                { text: "종합인테리어", value: true },
                { text: "부분인테리어", value: false },
            ],
        };
    },
};
</script>
